import useErrorStore from "stores/useErrorStore";

import Error401Page from "pages/error/Error401";
import Error403Page from "pages/error/Error403";
import Error404Page from "pages/error/Error404";
import Error500Page from "pages/error/Error500";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export const ErrorGuard = ({ children }: Props) => {
  const { errorCode } = useErrorStore();

  switch (errorCode) {
    case 401:
      return <Error401Page />;
    case 403:
      return <Error403Page />;
    case 404:
      return <Error404Page />;
    case 500:
      return <Error500Page />;
    default:
      return <>{children}</>;
  }
};
